import { useState, useEffect } from 'react'
import { moment } from 'localization'

const LastUpdate = (props) => {
	const { value } = props
	const [lastUpdate, setLastUpdate] = useState(value)
	useEffect(() => {
		const tick = setTimeout(() => {
			setLastUpdate(Date.now())
		}, 1000)
		return () => {
			clearTimeout(tick)
		}
	}, [lastUpdate])
	return moment(value).fromNow()
}

export default LastUpdate
